import styled, { DefaultTheme } from 'styled-components';
import { fjSelectTypes, fjSelectWidths } from 'components/primitives';

import { Select } from 'components/styled-primitives';

interface InputContainerProps {
  dataTestId?: string;
  customBottomMargin?: string;
}

export const Label = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.h5};
  margin-bottom: ${({ theme: { grid } }) => grid.units(0.5)};
`;

export const InputContainer = styled.div.attrs<InputContainerProps>(
  (props) => ({
    dataTestId: props.dataTestId,
  }),
)`
  margin-bottom: ${({ customBottomMargin, theme: { grid } }) =>
    customBottomMargin || grid.units(0.5)};
  display: flex;
  flex-direction: column;

  > :not(${Label}) {
    margin-left: ${({ theme: { grid } }) => grid.units(1)};
    margin-bottom: ${({ theme: { grid } }) => grid.units(0.5)};
  }
`;

export const MultiInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${InputContainer}:not(:first-child) > :not(${Label}) {
    margin-left: 0;
  }
  ${InputContainer}:not(:last-child) {
    margin-right: ${({ theme }) => theme.grid.units(1)};
  }
`;

export const WizardInnerPane = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex: 1;
  margin: 0 ${({ theme: { grid } }) => grid.units(1)};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const ModalSelect = styled(Select).attrs(
  ({ theme }: { theme: DefaultTheme }) => ({
    type: fjSelectTypes.LG,
    width: fjSelectWidths.WIDE,
    textColor: theme.colors.black,
    disabledOptionColor: theme.colors.buttonDisabled,
  }),
)``;
